// src/components/FormModal.jsx
import React, { useState, useEffect } from 'react'; // Adicionado useEffect
import { X, IdCard } from 'lucide-react';
import { LoaderCircle } from 'lucide-react';

// Adicionamos a prop 'initialDriverId' para o autopreenchimento
export default function FormModal({ isVisible, onClose, onSubmit, isLoading, initialDriverId = '' }) {
  const [driverId, setDriverId] = useState('');
  
  // Usamos useEffect para preencher o Driver ID quando o modal se torna visível
  useEffect(() => {
    if (isVisible) {
      setDriverId(initialDriverId);
    }
  }, [isVisible, initialDriverId]);

  if (!isVisible) {
    return null;
  }

  const handleDriverIdChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^[0-9\b]+$/.test(value)) {
      setDriverId(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!driverId) {
      alert('Por favor, preencha o campo Driver ID.');
      return;
    }
    
    if (driverId.length < 3 || driverId.length > 7) {
      alert('O Driver ID deve conter entre 3 e 7 números.');
      return;
    }

    onSubmit({ driverId, toField: "br" });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
      {/* Ajustado o tamanho máximo do modal */}
      <div className="bg-white rounded-2xl shadow-lg p-6 w-11/12 max-w-xs"> 
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-800">Enviar Imagem</h2>
          <button onClick={onClose} disabled={isLoading} className="p-1 rounded-full bg-gray-100 hover:bg-gray-200 disabled:opacity-50">
            <X size={20} className="text-gray-600" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          {/* O container agora tem apenas um item, que será centralizado */}
          <div className="space-y-4">
            <div className="relative">
              <IdCard size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={driverId}
                onChange={handleDriverIdChange}
                placeholder="Driver Id"
                disabled={isLoading}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#EE4D2D] disabled:bg-gray-100"
              />
            </div>
            {/* O campo BR (toField) foi removido da UI */}
          </div>
          
          <button
            type="submit"
            disabled={isLoading}
            className="mt-6 w-full flex justify-center items-center bg-[#EE4D2D] text-white font-bold py-3 rounded-lg hover:bg-[#D03F2A] transition-colors disabled:bg-red-300 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <LoaderCircle size={20} className="animate-spin mr-2" />
                Enviando...
              </>
            ) : (
              "Enviar Imagem"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}